const partnerPlaceholders = [
  { name: '合作伙伴A' },
  { name: '合作伙伴B' },
  { name: '合作伙伴C' },
  { name: '合作伙伴D' },
  { name: '合作伙伴E' },
  { name: '合作伙伴F' },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div>
              <span className="font-heading text-2xl font-black text-primary-400 whitespace-nowrap">51黑料</span>
              <p className="mt-4 text-sm text-background-400 leading-relaxed">
                51黑料吃瓜网是国内领先的娱乐八卦与黑料爆料聚合平台，每日实时更新最新吃瓜内容，覆盖娱乐圈、网红圈、综艺影视等多维度热点，为吃瓜群众提供即点即看的内容消费体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-100 mb-4">快速导航</h4>
              <nav className="flex flex-col gap-2">
                <a href="#hero" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
                <a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">焦点爆料</a>
                <a href="#about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">平台介绍</a>
                <a href="#app" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">APP下载</a>
                <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              </nav>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-100 mb-4">热门话题</h4>
              <div className="flex flex-wrap gap-2">
                <span className="px-2 py-1 rounded-md bg-background-800 text-background-300 text-xs whitespace-nowrap">51黑料吃瓜</span>
                <span className="px-2 py-1 rounded-md bg-background-800 text-background-300 text-xs whitespace-nowrap">吃瓜爆料</span>
                <span className="px-2 py-1 rounded-md bg-background-800 text-background-300 text-xs whitespace-nowrap">今日黑料</span>
                <span className="px-2 py-1 rounded-md bg-background-800 text-background-300 text-xs whitespace-nowrap">娱乐圈八卦</span>
                <span className="px-2 py-1 rounded-md bg-background-800 text-background-300 text-xs whitespace-nowrap">黑料今日头条</span>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-100 mb-4">合作伙伴</h4>
              <div className="grid grid-cols-3 gap-3">
                {partnerPlaceholders.map((p, i) => (
                  <div
                    key={i}
                    className="aspect-[3/2] rounded-lg bg-background-800/50 flex items-center justify-center"
                  >
                    <span className="text-xs text-background-500">{p.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 51黑料吃瓜网. 本站内容仅供娱乐参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#contact" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
              <a href="#faq" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}